import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { ContactoComponent } from './contacto/contacto.component';
import { AvisosComponent } from './avisos/avisos.component';
import { PortalService } from '../../services/portal.service';
import { NoticiasComponent } from './noticias/noticias.component';
import { SimbologiaComponent } from './simbologia/simbologia.component';
import { GuiaComponent } from './guia/guia.component';
import { ProfileComponent } from './profile/profile.component';
import { MenusComponent } from '../menus/menus.component';
import { ModuloAplicacionComponent } from '../modulo-aplicacion/modulo-aplicacion.component';
import { ErroresHandler } from '../../tools/handler/error.handler';
import { PanelControlService } from '../../services/panel_control.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { InitializationService } from '../../services/initialization.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    providers: [ConfirmationService],
})
export class HeaderComponent implements OnInit {
    config = this._config.get();
    user_online: any;
    avisos: [] = [];
    noticias: [] = [];
    title: string = this._config.get('SISTEMA.NOMBRE');
    tokenError: boolean = false;
    maintenance: boolean = false;

    @Output() header_emitter: EventEmitter<any> = new EventEmitter();

    @ViewChild(MenusComponent) menus: MenusComponent;
    @ViewChild(ModuloAplicacionComponent)
    modulo_aplicaciones: ModuloAplicacionComponent;
    @ViewChild(ContactoComponent) contacto: ContactoComponent;
    @ViewChild(AvisosComponent) avisos_component: AvisosComponent;
    @ViewChild(NoticiasComponent) noticias_component: NoticiasComponent;
    @ViewChild(SimbologiaComponent) simbologia_component: SimbologiaComponent;
    @ViewChild(ProfileComponent) profile: ProfileComponent;
    @ViewChild(GuiaComponent) guia: GuiaComponent;

    constructor(
        private _config: InitializationService,
        public translateService: TranslateService,
        private portalService: PortalService,
        private erroresHandler: ErroresHandler,
        private panelControlService: PanelControlService,
        private confirmationService: ConfirmationService,
        private router: Router
    ) {}

    async ngOnInit() {
        this.panelControlService.panel$.subscribe(async (res) => {
            let name = this._config.get('SISTEMA.NOMBRE');
            if (res['module'] != undefined) {
                name = res['module'].nombre;
                if (res['module'].estado == 2) {
                    let fg = await this.translateService
                        .get(['system_handler.maintenance.titulo'])
                        .toPromise();
                    this.maintenance = true;
                    this.router.navigate(['/maintenance'], {
                        state: {
                            mode: 'module',
                            name: fg['system_handler.maintenance.titulo'],
                        },
                    });
                }
            }
            this.title = name;
        });

        this.erroresHandler.error$.subscribe((res) => {
            this.tokenError = res.hasOwnProperty('token')
                ? res['token']
                : false;
        });

        this.user_online = JSON.parse(window.sessionStorage.getItem('user'));
        await this.get_avisos_noticias(
            this._config.get('SISTEMA.LOGIN')
                ? true
                : this._config.get('SISTEMA.GET_DATA')
        );
    }

    async get_avisos_noticias(loginCondition) {
        try {
            if (this._config.get('SISTEMA.LOGIN') && loginCondition) {
                if (this._config.get('SISTEMA.LOADS.AVISOS.DATA'))
                    this.avisos = await this.portalService.get_avisos();
                if (this._config.get('SISTEMA.LOADS.NOTICIAS.DATA'))
                    this.noticias = await this.portalService.get_noticias();
            }
        } catch (e) {
            this.erroresHandler.processError(e, 'none');
        }
    }

    async backToPortal() {
        let fg = await this.translateService
            .get([
                'button.volver_al_portal.text',
                'button.volver_al_portal.label',
            ])
            .toPromise();
        if (!this.tokenError) {
            if (window.innerWidth > 992) {
                this._backToPortal();
            } else {
                this.confirmationService.confirm({
                    header: fg['button.volver_al_portal.label'],
                    message: fg['button.volver_al_portal.text'],
                    accept: async () => {
                        this._backToPortal();
                    },
                });
            }
        }
    }

    async _backToPortal() {
        try {
            await this.portalService.backToPortal({
                proyecto: window.sessionStorage.getItem('proyecto'),
            });
        } catch (e) {
            let fg = await this.translateService
                .get(['button.volver_al_portal.error'])
                .toPromise();
            this.erroresHandler.processError(
                e,
                'alert',
                fg['button.volver_al_portal.error']
            );
        }
    }

    hideSidebar() {
        this.modulo_aplicaciones.show = false;
        this.menus.show = false;
    }

    show_menus_sidebar() {
        if (!this.tokenError && !this.maintenance) {
            this.modulo_aplicaciones.show = false;
            this.menus.do_show();
        }
    }

    show_modulos_aplicaciones_sidebar() {
        if (!this.tokenError) {
            this.menus.show = false;
            this.modulo_aplicaciones.do_show();
        }
    }

    goto_correo() {
        window.open(
            this._config.get('SISTEMA.CORREO_UV')[
                this._config.get('SISTEMA.CORREO_UV.EN_USO')
            ],
            '_blank'
        );
    }

    goto_cambiaclave() {
        window.open(this._config.get('SISTEMA.URL.CAMBIA_CLAVE'), '_blank');
    }

    async logout() {
        let fg = await this.translateService
            .get(['usuario.logout', 'usuario.logout_msgs'])
            .toPromise();
        if (window.innerWidth > 992) {
            this._logout();
        } else {
            this.confirmationService.confirm({
                header: fg['usuario.logout'],
                message: fg['usuario.logout_msgs'],
                accept: () => {
                    this._logout();
                },
            });
        }
    }

    _logout() {
        window.sessionStorage.clear();
        window.location.replace(this._config.get('SISTEMA.URL.PORTAL'));
    }
}
